import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Home from "../components/Home";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});

const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
const withTranslationComponent = withTranslation(["home", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Home.js